/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricerules_Mock_Bot_StatusInputs */

const tr_landing_pricerules_mock_bot_status = /** @type {(inputs: Landing_Pricerules_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`canlı · az önce`)
};

const en_landing_pricerules_mock_bot_status = /** @type {(inputs: Landing_Pricerules_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`live · just now`)
};

const de_landing_pricerules_mock_bot_status = /** @type {(inputs: Landing_Pricerules_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`live · gerade eben`)
};

const ru_landing_pricerules_mock_bot_status = /** @type {(inputs: Landing_Pricerules_Mock_Bot_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`онлайн · только что`)
};

/**
* | output |
* | --- |
* | "live · just now" |
*
* @param {Landing_Pricerules_Mock_Bot_StatusInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_pricerules_mock_bot_status = /** @type {((inputs?: Landing_Pricerules_Mock_Bot_StatusInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricerules_Mock_Bot_StatusInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricerules_mock_bot_status(inputs)
	if (locale === "de") return de_landing_pricerules_mock_bot_status(inputs)
	if (locale === "ru") return ru_landing_pricerules_mock_bot_status(inputs)
	return tr_landing_pricerules_mock_bot_status(inputs)
});